<template>
  <v-container>
    <RejectCommentLayout :comment-text="reject_comment" />
    <v-layout row justify-center>
      <v-flex md12>
        <v-form class="padding-20" ref="form">
          <v-row justify="center">
            <v-col cols="3">
              <v-select
                v-model="investigator.vacation.type"
                label="Vacation Type"
                required
                outlined
                :items="vacations"
                :disabled="disabledForm"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                readonly
                v-model="numberDays"
                label="Number of days"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <h4 class="text-left">Start Date</h4>
              <v-date-picker
                full-width
                v-model="investigator.vacation.start_date"
                :locale="$store.state.language"
                :disabled="disabledForm"
              />
            </v-col>
            <v-col cols="4" />
            <v-col cols="4">
              <h4 class="text-left">End Date</h4>
              <v-date-picker
                full-width
                v-model="investigator.vacation.end_date"
                :locale="$store.state.language"
                :min="investigator.vacation.start_date"
                :disabled="disabledForm"
              />
            </v-col>
          </v-row>
          <v-divider />
          <UserFormActions
            form_name_text="Vacation"
            :form_name="form_name"
            :refForm="$refs.form"
            :object_type="object_type"
            :data="processData"
            :state="state"
            @change-state="changeState"
          />
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import RejectCommentLayout from "../../layouts/RejectCommentLayout";
import UserFormActions from "../../action_buttons/UserFormActions";
import changeState from "../../../mixins/changeState";
import investigatorData from "../../../mixins/investigator_data";
import investigator_model from "../../../mixins/model_utils/investigator_model";

export default {
  mixins: [changeState, investigatorData, investigator_model],
  components: { RejectCommentLayout, UserFormActions },

  data: () => ({
    form_name: "vacationForm",
    object_type: "investigator",
    state: "",
    reject_comment: "",
  }),

  created() {
    this.getVacations();
    this.getData();
  },

  computed: {
    numberDays() {
      var startDate = new Date(this.investigator.vacation.start_date);
      var endDate = new Date(this.investigator.vacation.end_date);

      var numWorkDays = 0;
      while (startDate <= endDate) {
        if (startDate.getDay() !== 0 && startDate.getDay() !== 6) {
          numWorkDays++;
        }
        startDate.setDate(startDate.getDate() + 1);
      }
      return numWorkDays;
    },
    updateVacationForm() {
      return this.$route.meta.updateForm;
    },
    rejectedForm() {
      return this.state === "RJ";
    },
    disabledForm() {
      let states = ["VD", "PA", "PV", "PC"];
      return states.includes(this.state);
    },

    processData() {
      return {
        title: this.investigator.name,
        object_type: this.object_type,
        form_name: this.form_name,
        object_id: this.investigator.id,
        data: {
          user: {
            person: this.investigator.id,
            type: this.investigator.vacation.type,
            start_date: this.investigator.vacation.start_date,
            end_date: this.investigator.vacation.end_date,
            days_count: this.numberDays
          }
        }
      };
    }
  },

  methods: {
    getData() {
      let path = "";
      if (this.updateVacationForm || this.$route.meta.readOnly) {
        path =
          this.$store.state.endpoint +
          "/user/moderatedOperations/investigator/" +
          this.$route.params.id;
        axios
          .get(path)
          .then(response => {
            this.investigator.vacation = response.data.data.user;
            this.state = response.data.state;
            this.reject_comment = response.data.reject_comment;
            this.investigator.id = response.data.object_id;
            this.getInvestigatorName(this.$store.state.endpoint + "/person/" + this.investigator.id);
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.getInvestigatorName(this.$store.state.endpoint + "/person/" + this.$route.params.id);
      }
    },
  }
};
</script>
